module.exports = __webpack_public_path__ + "static/media/annaNorman.ee674bc8.jpg";